/// <reference path="../../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;

	export class RouteTail extends View<THREE.Sprite> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor(color:THREE.Color) {
			super();

			this.color = color;

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():THREE.Sprite {
			this.texture = new THREE.TextureLoader().load('image/route-head.png');
			this.material = new THREE.SpriteMaterial({
				map: this.texture,
				color: this.color,
				transparent: true,
				depthWrite: false
			});
			const view:THREE.Sprite = new THREE.Sprite(this.material);
			const scale:number = 5;
			view.scale.set(scale, scale, scale);

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:THREE.Sprite, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = true;
			});
		}

		protected implHide(view:THREE.Sprite, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.visible = false;
			});
		}

		public updatePosition(position:THREE.Vector3):void {
			this.getView().position.set(position.x, position.y + 1, position.z);
		}





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private color:THREE.Color;

		private texture:THREE.Texture;
		private material:THREE.SpriteMaterial;
	}
}
